import CalendarEvents from './component';

export default CalendarEvents;
